"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const use_search_1 = __importDefault(require("@/SearchApp/composables/use-search"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TypeAhead',
    setup(__props) {
        const { isSearchMostSuggested } = (0, use_search_1.default)();
        const FindingsShop = (0, vue_3.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require("./FindingsShop.vue"))));
        const FindingsMostSuggested = (0, vue_3.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require("./FindingsMostSuggested.vue"))));
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(isSearchMostSuggested))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(FindingsMostSuggested), { key: 0 }))
                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(FindingsShop), { key: 1 }));
        };
    }
});
